import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { Avatar, AvatarFallback, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { Settings } from '@repo/ui/icons';
import { KitAvatar } from '../../avatar/avatar.tsx';
const getActorName = (entry: GetHistoryEntry) => {
  if (entry.is_system) return 'System';
  return `${entry.user.name}${entry.user.last_name ? ` ${entry.user.last_name}` : ''}`;
};
export const HistoryAvatar = t0 => {
  const $ = _c(16);
  const {
    entry
  } = t0;
  let t1;
  if ($[0] !== entry) {
    t1 = getActorName(entry);
    $[0] = entry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const actorName = t1;
  let t2;
  if ($[2] !== actorName) {
    t2 = <span aria-label={actorName} className="inline-flex shrink-0" />;
    $[2] = actorName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== actorName || $[5] !== entry.is_system || $[6] !== entry.user) {
    t3 = entry.is_system ? <Avatar className="size-6" size="sm"><AvatarFallback><Settings aria-hidden="true" className="size-3.5" /></AvatarFallback></Avatar> : <KitAvatar alt={actorName} className="size-6" size="sm" user={entry.user} />;
    $[4] = actorName;
    $[5] = entry.is_system;
    $[6] = entry.user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <TooltipTrigger render={t2} data-sentry-element="TooltipTrigger" data-sentry-source-file="history-avatar.tsx">{t3}</TooltipTrigger>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== actorName) {
    t5 = <TooltipContent data-sentry-element="TooltipContent" data-sentry-source-file="history-avatar.tsx">{actorName}</TooltipContent>;
    $[11] = actorName;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="HistoryAvatar" data-sentry-source-file="history-avatar.tsx">{t4}{t5}</Tooltip>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};